import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-accordioncontent',
    content: 'p-accordioncontent-content'
};

export default BaseStyle.extend({
    name: 'accordioncontent',
    classes
});
